import { useQuery } from "react-query"
import PortfolioService from "~services/PortfolioService"

const useSecurities = () => {
  return useQuery("securities", () => PortfolioService.getSecurities(), {
    staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes
    retry: 3, // Retry failed requests up to 3 times
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data exists
    refetchOnReconnect: false, // Don't refetch when reconnecting to network
  })
}

export default useSecurities
